import { stenaPercentage } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const TargetFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { target, setTarget } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setTarget({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return target.from || target.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"target"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaPercentage}
      children={
        <RangeControl<RangeFilter>
          value={target}
          valueFrom={target.from}
          valueTo={target.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={maxNumbers}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
